module.exports = __webpack_public_path__ + "static/reviewer-58ca14f0d47257d9a861fe9745a6b6fb.jpeg";